import { useNavigate } from 'react-router-dom'
import { BsArrowLeftShort } from 'react-icons/bs'
import DownloadButton from '../Components/DownloadButton'
// import JasonCarmichaelResume from '../Images/JasonCarmichaelResume.pdf'
import JasonCarmichaelCV from '../Images/JasonCarmichael_CV_0523fe.pdf'

export default function About () {

    let navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }

    return (
        <div className="about-me-container">
            <section className="bg-gradient-to-bl from-gray-900 via-gray-800 to-gray-900 dark:bg-gray-900">
                
                <span className="place-self-start mt-5 ml-3">
                    <button className="inline-flex items-center px-4 py-2 mr-3 text-sm font-medium text-gray-400  rounded-lg hover:bg-green-500 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white" id="back-button" onClick={goBack}>
                        <BsArrowLeftShort size={30}/>
                    </button>
                </span>

                <h2 className="mb-4 text-3xl lg:text-4xl tracking-wide font-extrabold text-white text-center dark:text-white">About Me</h2>

                <div className="flex justify-between px-6 mx-auto max-w-screen-md md:px-10">

                {/* <div className="gap-8 items-center pb-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-4 lg:px-6"> */}
                    {/* <img className="w-full dark:hidden" src={} alt="my_photo"/> */}

                    <div className="mt-4 mb-10 md:mt-0">
                        <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">Background</h4>
                        <p className="mb-6 font-light text-gray-200 leading-relaxed md:text-lg dark:text-gray-400">I am a graduate of General Assembly's Software Engineering Immersive program with a background in elementary education, publishing, and higher education facilities and operations. These experiences honed my skills in managing projects, analyzing and understanding problems, and developing / implementing systems and processes to address problems.
                        </p>
                        <p className="mb-6 font-light text-gray-200 leading-relaxed md:text-lg dark:text-gray-400">Also, I have prior training in UX / UI design. Previously, I earned a certificate for completing a UX Design course through CareerFoundry. As a result, I approach software engineering with consideration of end users and each of the different stakeholders involved in the product development process. I especially enjoying applying these skills to front-end projects.</p>
                        <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">What My Colleagues Say</h4>
                        <p className="mb-6 font-light text-gray-200 leading-relaxed md:text-lg dark:text-gray-400">People I work with know me by my calm demeanor. As a result of my calm presence, colleagues have found in me an active listener who is approachable, trustworthy, and confidential. Also, they have valued my critical thinking skills and insightful input offered in a non-judgmental manner. Others have appreciated my ability to think deeply and carefully about particular problems from a unique perspective.</p>

                        <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">Interests</h4>
                        <div className="mb-4">
                            <p className="mb-6 font-light text-gray-200 leading-relaxed md:text-lg dark:text-gray-400">In my free time, I enjoy reading fiction and poetry, pondering philosophy, writing creatively, practicing tai chi, and spending time with my family.</p>
                        </div>

                        <div className="mb-4" id="downloadResume">
                            <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">Resume</h4>
                            <div className="mb-4">
                                <p className="mb-8 font-light text-gray-200 md:text-lg dark:text-gray-400">Click on the button below to download my resume.</p>
                                <DownloadButton
                                    url={JasonCarmichaelCV}
                                    download={true}>Download Resume PDF</DownloadButton>
                            </div>
                        </div>
                    </div>  
                </div>
            </section>
        </div>
    )
}

